import { useRouteContext } from './useRouteContext';

export function useRoutes() {
  const routeMap = useRouteContext();
  return Object.values(routeMap).filter(route => route.exists);
}
